module.exports = __webpack_public_path__ + "static/neihu5-54a535555498a1377235e8a809986d3d.jpg";